import React from "react";
import FilterByType from "./Job Filters/FilterByType";
import FilterByCity from "./Job Filters/FilterByLocation";
import FilterByExp from "./Job Filters/FilterByExp";
import { Box } from "@mui/material";
import { filterAction } from "./Reducer/FilterReducer";
import FilterByVisibility from "./Job Filters/FilterByVisibility";
import FilterByExpirationDate from "./Job Filters/FilterByExpirationStatus";
import useAuth from "app/hooks/useAuth";

function JobListFilter({ filter, dispatchFilter }) {
  const { user } = useAuth();
  const isCandidate = user?.role === "candidate";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        mt: 2,
        borderRadius: 2,
        width: "100%",
        gap: 2
      }}
    >
      <FilterByType
        value={filter.type}
        onChecked={(type) => {
          dispatchFilter({ type: filterAction.SET_TYPE, payload: type });
        }}
      />
      <FilterByExp
        value={filter.exp}
        onChecked={(exp) => {
          dispatchFilter({ type: filterAction.SET_EXP, payload: exp });
        }}
      />
      <FilterByCity
        value={filter.city}
        onChange={(location) => {
          dispatchFilter({ type: filterAction.SET_CITY, payload: location });
        }}
      />

      {!isCandidate && (
        <>
          <FilterByVisibility
            value={filter.visibility}
            onChange={(visibility) => {
              dispatchFilter({ type: filterAction.SET_VISIBILITY, payload: visibility });
            }}
          />
          <FilterByExpirationDate
            value={filter.expirationStatus}
            onChange={(status) => {
              dispatchFilter({ type: filterAction.SET_EXPIRATION_STATUS, payload: status });
            }}
          />
        </>
      )}
    </Box>
  );
}

export default JobListFilter;
